<template>
  <div id="app">
    <router-view/>
    <!-- <router-view  v-wechat-title="$route.meta.title"/> -->
  </div>
</template>

<script>
export default {
  name: 'App'
}

</script>



// WEBPACK FOOTER //
// src/App.vue